import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { commonStore } from "./commonStore";

// Standalone store (mirrors canvasDesignStore): spreads commonStore.state to reuse
// the authenticated axios client, and talks to the /api/routine endpoints.
const getInitialState = () => ({
    ...commonStore.state,
    routines: [],
    runs: [],
    loading: false,
});

export const routineStore = new Vuex.Store({
    state: getInitialState(),
    mutations: {
        resetState(state) {
            Object.assign(state, getInitialState());
        },
        setRoutines(state, list) {
            state.routines = list || [];
        },
        setRuns(state, list) {
            state.runs = list || [];
        },
        setLoading(state, value) {
            state.loading = value;
        },
    },
    actions: {
        async loadRoutines(context, payload) {
            const scope = (payload && payload.scope) || "mine";
            context.commit("setLoading", true);
            try {
                const res = await context.state.client.get(`/api/routine?scope=${scope}`);
                context.commit("setRoutines", res.data);
                return res.data;
            } finally {
                context.commit("setLoading", false);
            }
        },

        async getRoutine(context, id) {
            const res = await context.state.client.get(`/api/routine/${id}`);
            return res.data;
        },

        async saveRoutine(context, routine) {
            const res = await context.state.client.post(`/api/routine`, routine);
            return res.data;
        },

        async deleteRoutine(context, id) {
            return await context.state.client.delete(`/api/routine/${id}`);
        },

        // payload: { id, dryRun }
        async runRoutine(context, payload) {
            const dryRun = !!(payload && payload.dryRun);
            const res = await context.state.client.post(
                `/api/routine/${payload.id}/run?dryRun=${dryRun}`, {});
            return res.data;
        },

        async loadRuns(context, id) {
            const res = await context.state.client.get(`/api/routine/${id}/runs`);
            context.commit("setRuns", res.data);
            return res.data;
        },

        // Flip enabled and persist (re-arms/cancels server-side).
        async toggleRoutine(context, routine) {
            const updated = Object.assign({}, routine, { enabled: !routine.enabled });
            const res = await context.state.client.post(`/api/routine`, updated);
            return res.data;
        },
    },
});

export default routineStore;
